export default "__VITE_ASSET__BNXHTr92__"